export default __webpack_public_path__ + "static/media/favorite-unfilled.41887538.svg";